export default __webpack_public_path__ + "static/media/moca-lows.5e64b6cd.webp";